<template>
  <el-container>
    <el-aside width="200px"></el-aside>
    <el-main class="custom-main">
      <el-row :gutter="20" class="custom-row">
        <el-col :span="6"><Rawtablefig1 /></el-col>
        <el-col :span="6"><Rawtablefig3 /></el-col>
        <el-col :span="6"><Rawtablefig4 /></el-col>
        <el-col :span="6"><Rawtablefig2 /></el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom: 30px;">
        <Rawtable />
      </el-row>
    </el-main>
    <el-aside width="200px"></el-aside>    
  </el-container>
</template>

<script>
import Rawtable from './statistics/Rawtable.vue';
import Rawtablefig1 from './statistics/Rawtablefig1.vue';
import Rawtablefig2 from './statistics/Rawtablefig2.vue';
import Rawtablefig3 from './statistics/Rawtablefig3.vue';
import Rawtablefig4 from './statistics/Rawtablefig4.vue';

export default {
  components: {
    Rawtable,Rawtablefig1,Rawtablefig2,Rawtablefig3,Rawtablefig4
  },
};
</script>

<style scoped>
.custom-main {
  margin-top: 60px;
}
.custom-row {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Statistics.vue